
import { EnrollmentStatusEntity } from "infrastructure/services/types/enrollments.entity";
import { RootState } from "./rootReducer";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  enrollmentId: '',
  status: '',
  updatedAt: '',
} as EnrollmentStatusEntity;

export const enrollmentAuthenticationUserReducer = createSlice({
  name: "EnrollmentAuthenticationUser",
  initialState,
  reducers: {
    saveAuthenticationUser: (state, action: PayloadAction<EnrollmentStatusEntity>) => {
      return action.payload;
    },
    resetAuthenticationUser: () => {
      return initialState;
    },
  },
});

export const { resetAuthenticationUser, saveAuthenticationUser } = enrollmentAuthenticationUserReducer.actions;

export const getEnrollmentAuthenticationUserRedux = (state: RootState) => { return state };
export const getEnrollmentAuthenticationUserStatus = (state: RootState) => { return state.enrollmentAuthenticationUserReducer.status };

export default enrollmentAuthenticationUserReducer.reducer;
